export default __webpack_public_path__ + "static/media/yomafleet_truck_and_trailer.8652671e.png";